import dayjs from "dayjs";
import { useEffect } from "react";

export const useConversionId = () => {
  useEffect(() => {
    const currentConversionId = sessionStorage.getItem("tw-conversion-id");
    if (!currentConversionId) {
      const timestamp = dayjs().unix();
      const conversionId = `tw-${timestamp}`;
      sessionStorage.setItem("tw-conversion-id", conversionId);
    }
  }, []);
};

export const getConversionId = () => {
  const currentConversionId = sessionStorage.getItem("tw-conversion-id");
  if (!currentConversionId) {
    const timestamp = dayjs().unix();
    const conversionId = `tw-${timestamp}`;
    sessionStorage.setItem("tw-conversion-id", conversionId);
    return conversionId;
  }
  return currentConversionId;
};

export const setConversionId = (conversionId: string) => {
  sessionStorage.setItem("tw-conversion-id", conversionId);
};
